import { unWrapNull } from 'src/common/utils/unWrapNull';

const CARD_TITLE_INDEXABLE_INDICATOR = /\sx$/gm;

export const getIndexedTitle = (title: string, index: number) =>
  title.replace(CARD_TITLE_INDEXABLE_INDICATOR, ` ${index + 1}`);

export const getMissingFieldLabel = (
  index: number,
  isAddable: boolean | undefined,
  label: string,
  cardTitle?: string,
) => {
  return isAddable && cardTitle
    ? `${getIndexedTitle(cardTitle, index)} ${label}`
    : label;
};

export const getCardFormDataPath = (
  card:
    | { entity?: string | null; entityType?: string | null }
    | undefined
    | null,
  order?: number,
) =>
  [
    unWrapNull<string>(card?.entity) ?? '',
    unWrapNull<string>(card?.entityType) ?? '',
    order ?? '',
  ]
    .filter((path) => `${path}`.length)
    .join('.');

export const getCardId = (cardId: string, index: number) =>
  `${cardId}-${index}`;
